import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppWithAnalytics from '@pages/AppWithAnalytics';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithAnalytics />
  </StrictMode>
);
